import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { BaseFilter } from '../../common/facet';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    focusElementByQuery
} from '../../common/util/';


@Component({
    selector: 'protocol-filter',
    templateUrl: './protocol-filter.component.html'
})
export class ProtocolFilterComponent extends BaseFilter implements OnInit {
    @Input() filter: any = {};
    @Output() onFilter = new EventEmitter<any>();
    @Output() close = new EventEmitter<any>();


    constructor(
        private activeModal: NgbActiveModal
    ) {
        super(activeModal);
    }

    ngOnInit() {
        this.cloneFilter();

        focusElementByQuery('[data-auto-focus="protocolName"]');
    }

    private cloneFilter() {
        this.filter = this.copyFilter(this.filter);
    }

    filterClicked(event: Event) {
        event.preventDefault();
        this.onFilter.emit(this.filter);
        this.close.emit();
        this.activeModal.close();
    }

    closeClicked() {
        this.close.emit();
        this.activeModal.dismiss();
    }

    clearClicked() {
        this.filter = {};
        this.onFilter.emit(this.filter);
        this.close.emit();
        this.activeModal.close();
    }
}
